import { LoaderFunction } from "react-router-dom";
import { authApi } from "../../services/auth";
import store from "../../store";
import { authLoader } from "./authLoader";

const getHostname = () => {
  return `${window.location.origin}/auth-callback.html`;
};

export const ssoLoader = async () => {
  const { data: ssoProvidersList } = await store.dispatch(
    authApi.endpoints.getSSOProviders.initiate({ hostname: getHostname() })
  );

  return { ssoProvidersList: ssoProvidersList ?? [] };
};

export const LoginLoader: LoaderFunction = async () => {
  const authData = await authLoader();

  // Spreading a Response would silently drop the redirect, so return it as-is.
  if (authData instanceof Response) return authData;

  const ssoData = await ssoLoader();

  return { ...authData, ...ssoData };
};
